import * as CryptoJS from 'crypto-js';

import { inject, Injectable } from '@angular/core';

import { CORE_CONFIG } from '../config/core-config';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  privateKey = inject(CORE_CONFIG).cryptoKey;

  encrypt(value: string, key: string = this.privateKey): string {
    if (!value) {
      return '';
    }
    return CryptoJS.AES.encrypt(value, key).toString();
  }

  decrypt(value: string, key: string = this.privateKey): string {
    if (!value) {
      return '';
    }
    return CryptoJS.AES.decrypt(value, key).toString(CryptoJS.enc.Utf8);
  }
}
